import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

// import FGDashboard from "./fg-dashboard.js";
import OverviewDashboard from "./fg-dashboard2.js";
import WHLaneFill from "./warehouselanefill.js"
import StockToNorm from "./stocktonorm.js"


const tabs = [
    { label: "Overview Dashboard", value: "overviewdashboard" },
  // { label: "FG Inventory Dashboard", value: "fginventorydashboard" },
    { label: "Stock To Norm", value: "stocktonorm" },
    { label: "Warehouse Lane Fill", value: "warehouselanefill" },




];

const Dashboards = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "overviewdashboard";

  const [activeTab, setActiveTab] = useState(defaultTab);

  // Sync tab with URL
  useEffect(() => {
    setSearchParams({ tab: activeTab });
  }, [activeTab, setSearchParams]);

  const handleTabClick = (tabValue) => {
    setActiveTab(tabValue);
  };

  return (
    <div className="container mt-2 pl-2 pr-2">

      {/* ---------- Page Heading ---------- */}
      <div className="col-sm-12 p-0">
        <h1
          style={{
            color: "#B9366D",
            fontSize: 18,
            fontWeight: "bold",
            fontFamily: "sans-serif",
            marginBottom: "10px",
            position: "sticky",
            background: "#F7EEF2",
            zIndex: 20,
            marginTop:"-5px"
          }}
        >
          FG Analytics Dashboards
        </h1>
      </div>

      <div
        className="col-sm-12 p-0 mt-2"
        style={{
          position: "sticky",
          top: 0,
          background: "#fff",
          zIndex: 20,
        }}
      >
        <ul
          className="nav nav-tabs"
          role="tablist"
          style={{
            borderBottom: "1px solid #dee2e6",
            background: "#F7EEF2",
            zIndex: 20,
          }}
        >
          {tabs.map((tab) => (
            <li key={tab.value} className="nav-item" role="presentation">
              <button
                type="button"
                className={`nav-link ${activeTab === tab.value ? "active" : ""}`}
                onClick={() => handleTabClick(tab.value)}
                style={{
                  fontSize: "14px",
                  fontWeight: activeTab === tab.value ? 600 : 500,
                  color: activeTab === tab.value ? "#93385D" : "#555",
                  backgroundColor: activeTab === tab.value ? "#fff" : "#f8f9fa",
                  border: "none",
                  borderBottom: `2px solid ${
                    activeTab === tab.value ? "#93385D" : "transparent"
                  }`,
                  padding: "8px 20px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* ---------- Tab Content ---------- */}
      <div style={{ marginTop: "30px", fontSize: "16px" }}>
        {/* {activeTab === "fginventorydashboard" && <FGDashboard />} */}
        {activeTab === "overviewdashboard" && <OverviewDashboard />}
        {activeTab === "warehouselanefill" && <WHLaneFill/>}
        {activeTab === "stocktonorm" && <StockToNorm/>}
      </div>
    </div>
  );
};

export default Dashboards;
